import * as R from 'rambda'

export async function KeyedPromises(promises: {
  [key: string]: Promise<unknown> | unknown
}): Promise<Record<string, unknown>> {
  const values = await Promise.all(R.values(promises))
  const keys = R.keys(promises) as string[]
  return R.zipObj(keys, values)
}
